module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list-details-order"
  }, [_c('div', {
    staticClass: "list-details-order-bloc"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("orders.orderWindow.titleOrderLink")))]), _vm._v(" "), (!_vm.orderWindow.length) ? _c('div', {
    staticClass: "orderWindowEmpty"
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.msgEmptyOrder")))]) : _vm._e(), _vm._v(" "), (_vm.orderWindow.length) ? _c('table', {
    staticClass: "table table-header"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.orderId")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.buyer")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.status")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.lastUpdate")))])])]), _vm._v(" "), _vm._l((_vm.orderWindow), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'MyOrder',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.reference))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createdBy.firstname) + " " + _vm._s(item.createdBy.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTranslate(item.status.name)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.modifiedDate))])])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b8938e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/summary-common/listDetailsOrder.vue
// module id = 3247
// module chunks = 0